import { isEmpty, isObject, get } from 'lodash'
import Cache from '../lib/cache'
import Vue from 'vue'

/**
 *
 * @param globals
 */
const clearGlobals = (globals) =>
  globals.reduce((accu, globalVariable) => {
    return `${accu} const ${globalVariable} = undefined;`
  }, '')

const timeout = 5000
let keysToLocalize = []

let saveData = () => {
  if (isEmpty(keysToLocalize)) return
  Vue.prototype.$client
    .execute({
      operationId: 'Localization_saveData',
      method: 'post',
      parameters: {
        data: JSON.stringify(keysToLocalize),
      },
      requestContentType: 'application/x-www-form-urlencoded',
    })
    .catch((e) => {
      keysToLocalize = []
      console.error('Localization_saveData', e)
    })
    .then(() => {
      keysToLocalize = []
      const cache = Cache.create('getTranslation')
      if (cache.exists()) return cache.remove()
    })
}

let localize = setTimeout(() => saveData(), timeout)

const addKeysToLocalize = (value) => {
  if (!keysToLocalize.find((item) => item.key === value.key)) {
    keysToLocalize.push(value)
    clearTimeout(localize)
    localize = setTimeout(() => saveData(), timeout)
  }
}

/**
 *
 * @type {{install(*, *): void}}
 */
const i18n = {
  install(Vue, options) {
    Vue.prototype.$i18n = {
      t(key, locale) {
        let localKey
        const localObjNotEmpty = isObject(locale) && !isEmpty(locale)
        if (localObjNotEmpty) {
          Object.assign(locale, { lang: options.defaultLocale })
          localKey = options.defaultLocale
        } else {
          localKey = locale || options.defaultLocale
        }

        const category = localObjNotEmpty ? locale.category : 'vue-i18n'

        if (!options[localKey]) {
          addKeysToLocalize({
            key,
            category: category || '',
            values: [],
          })

          return key
        } else {
          if (key) {
            if (options.simpleKey) {
              if (get(options, [localKey, key])) {
                return options[localKey][key].text || key
              } else {
                addKeysToLocalize({
                  key,
                  category: category || '',
                  values: [],
                })
                return key
              }
            } else {
              return key.split('.').reduce((trans, keyPart) => {
                if (trans[keyPart]) {
                  return trans[keyPart]
                }
                return key
              }, options[localKey])
            }
          }
        }
      },
      interpolate(template, params = {}) {
        const names = Object.keys(params)
        const vals = Object.values(params)
        const globals = ['process', 'global', 'window', 'self', 'document']
        // eslint-disable-next-line no-new-func
        try {
          return new Function(
            ...names,
            `return (function(){
              'use strict'; ${clearGlobals(globals)} return \`${template}\`;
            }).call(undefined)`,
          )(...vals)
        } catch (e) {
          return template
        }
      },
    }
  },
}

export default i18n
